"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const analyticsService_1 = require("../../services/analyticsService");
const common_1 = require("../../utils/common");
const pageView = () => {
    (0, analyticsService_1.logEvent)("PageEntered", {});
};
function head() {
    (0, analyticsService_1.initAmplitude)();
    (0, common_1.UpdateCookieWithUrlParams)();
    pageView(); // page view event
}
head();
